import api from '../api/client';
import { getOAuthLegalConsent, clearOAuthLegalConsent } from '../components/SocialLoginButtons';

/**
 * After OAuth, archive legal consent from sessionStorage.
 * Login click-wrap: only accepts docs still pending (new users).
 * Signup checkbox: accepts all stored document IDs.
 */
export async function recordOAuthLegalConsent(refreshPendingConsents) {
  const oauthConsent = getOAuthLegalConsent();
  if (!oauthConsent?.documentIds?.length) return { recorded: false };

  let documentIds = oauthConsent.documentIds;

  if (oauthConsent.method === 'login_clickwrap') {
    const { data } = await api.legal.getPending();
    const pendingIds = new Set((data.pending || []).map((p) => p.id));
    documentIds = oauthConsent.documentIds.filter((id) => pendingIds.has(id));
    if (!documentIds.length) {
      clearOAuthLegalConsent();
      return { recorded: false, skipped: 'already_accepted' };
    }
  }

  await api.legal.acceptConsent({
    documentIds,
    consentMethod: oauthConsent.method,
    consentClickedAt: oauthConsent.clickedAt,
  });
  if (refreshPendingConsents) {
    await refreshPendingConsents();
  }
  clearOAuthLegalConsent();
  return { recorded: true, documentIds, method: oauthConsent.method };
}
